const BASE_DOMAIN = '';

export { BASE_DOMAIN };
